import { render, staticRenderFns } from "./AttachXmlFile.vue?vue&type=template&id=2d3bb511&scoped=true"
import script from "./AttachXmlFile.vue?vue&type=script&lang=js"
export * from "./AttachXmlFile.vue?vue&type=script&lang=js"
import style0 from "./AttachXmlFile.vue?vue&type=style&index=0&id=2d3bb511&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3bb511",
  null
  
)

export default component.exports